// index.js
import Vue from 'vue'
import VueI18n from 'vue-i18n'
import fr from './fr.json'
import nl from './nl.json'

Vue.use(VueI18n);

const defaultLocale = 'fr'

const languages = {
  fr: fr,
  nl: nl
}

const messages = Object.assign(languages)

var i18n = new VueI18n({
  locale: defaultLocale,
  fallbackLocale: 'fr',
  messages
})

export { i18n };


// WEBPACK FOOTER //
// ./src/locales/index.js